/* =============================================================
   <aisen-meter-selector> — venda por metragem (Etapa 1)
   Vanilla Web Component. Sem React, sem dependências.
   1 unidade Shopify = data-unit metros (default 5).
   ============================================================= */
(function () {
  'use strict';
  if (customElements.get('aisen-meter-selector')) return;

  var DEV = window.Shopify && window.Shopify.designMode; // Theme Editor

  class AisenMeterSelector extends HTMLElement {
    connectedCallback() {
      if (this._init) return;          // guarda: inicializa uma única vez por instância
      this._init = true;
      this._ac = new AbortController();
      var signal = this._ac.signal;

      // --- config ---
      this.unit = parseInt(this.dataset.unit || '5', 10);
      this.min = parseInt(this.dataset.min || '5', 10);
      this.step = parseInt(this.dataset.increment || '5', 10);
      this.max = parseInt(this.dataset.max || '500', 10);
      this.maxCircuit = parseInt(this.dataset.maxCircuit || '50', 10);
      this.quoteUrl = this.dataset.quoteUrl || '#';
      this.currency = this.dataset.currency || 'BRL';
      this.locale = this.dataset.locale || 'pt-BR';

      // --- variantes ---
      try {
        var raw = this.querySelector('[data-variants]');
        this.variants = raw ? JSON.parse(raw.textContent) : [];
      } catch (e) { this.variants = []; console.warn('[aisen] variantes inválidas', e); }

      // --- refs ---
      this.input = this.querySelector('[data-meter-input]');
      this.decBtn = this.querySelector('[data-meter-dec]');
      this.incBtn = this.querySelector('[data-meter-inc]');
      this.addBtn = this.querySelector('[data-add]');
      this.quoteBtn = this.querySelector('[data-quote]');
      this.live = this.querySelector('[data-live]');
      this.qtyInput = this.querySelector('[data-qty]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('[name="aisen-power"]'));

      this.currentVariant = this._selectedVariant();
      this.meters = this._clamp(parseInt(this.input && this.input.value, 10) || this.min);

      // --- listeners (todos com signal → limpos em disconnected) ---
      if (this.decBtn) this.decBtn.addEventListener('click', () => this._setMeters(this.meters - this.step), { signal });
      if (this.incBtn) this.incBtn.addEventListener('click', () => this._setMeters(this.meters + this.step), { signal });
      if (this.input) {
        this.input.addEventListener('change', () => this._setMeters(parseInt(this.input.value, 10)), { signal });
        this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this._setMeters(parseInt(this.input.value, 10)); } }, { signal });
      }
      this.radios.forEach((r) => r.addEventListener('change', () => { this.currentVariant = this._selectedVariant(); this.render(); }, { signal }));
      if (this.addBtn) this.addBtn.addEventListener('click', (e) => this._onAdd(e), { signal });

      this._devWarnMetafields();
      this.render();
    }

    disconnectedCallback() { if (this._ac) this._ac.abort(); this._init = false; }

    // ---- helpers ----
    _selectedVariant() {
      var checked = this.radios && this.radios.filter((r) => r.checked)[0];
      var id = checked ? checked.value : (this.dataset.selectedVariant || (this.variants[0] && this.variants[0].id));
      return this.variants.filter((v) => String(v.id) === String(id))[0] || this.variants[0] || null;
    }
    _clamp(m) {
      if (isNaN(m)) m = this.min;
      m = Math.round(m / this.step) * this.step;          // trava no incremento
      if (m < this.min) m = this.min;
      if (m > this.max) m = this.max;                       // UI trava no máximo online
      return m;
    }
    _setMeters(m) { this.meters = this._clamp(m); this.render(); }
    _quantity() { return Math.round(this.meters / this.unit); }
    _money(cents) {
      try { return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(cents / 100); }
      catch (e) { return 'R$ ' + (cents / 100).toFixed(2); }
    }
    _say(msg) { if (this.live) this.live.textContent = msg; }

    // ---- render ----
    render() {
      var v = this.currentVariant;
      if (this.input) { this.input.value = this.meters; this.input.setAttribute('aria-valuenow', this.meters); }
      if (this.decBtn) this.decBtn.disabled = this.meters <= this.min;
      if (this.incBtn) this.incBtn.disabled = this.meters >= this.max;

      var price = v ? v.price : 0;                          // preço da variante = `unit` metros
      var perM = price / this.unit;
      var total = price * this._quantity();

      this._setText('[data-price-per-5]', this._money(price));
      this._setText('[data-price-per-m]', this._money(perM));
      this._setText('[data-total]', this._money(total));

      // código técnico visível + tensão
      if (v) { this._setText('[data-tech-code]', v.sku || v.title); }

      // prazo dinâmico (faixa)
      this._setText('[data-delivery]', this._deliveryText(this.meters));

      // qty oculto + line item properties
      var qty = this._quantity();
      if (this.qtyInput) this.qtyInput.value = qty;
      this._setProp('Metragem total', this.meters + ' metros');
      this._setProp('Código técnico', v ? (v.sku || v.title) : '');
      this._setProp('Tensão', this.dataset.voltage || '220 V');
      this._setProp('_total_meters', String(this.meters));
      this._setProp('_sales_unit_m', String(this.unit));
      this._setProp('_max_circuit_m', String(this.maxCircuit));

      // estados do botão
      var available = v && v.available;
      var overMax = this.meters >= this.max; // no máximo → oferecer cotação acima
      var reallyOver = this.meters > this.max;
      if (this.addBtn && this.quoteBtn) {
        if (!available) {
          this.addBtn.hidden = false; this.quoteBtn.hidden = true;
          this.addBtn.disabled = true; this.addBtn.textContent = 'PRODUTO INDISPONÍVEL';
        } else if (reallyOver) {
          this.addBtn.hidden = true; this.quoteBtn.hidden = false;
          this.quoteBtn.href = this.quoteUrl; this.quoteBtn.textContent = 'SOLICITAR COTAÇÃO';
        } else {
          this.addBtn.hidden = false; this.quoteBtn.hidden = true;
          this.addBtn.disabled = false;
          this.addBtn.textContent = 'ADICIONAR ' + this.meters + ' METROS AO CARRINHO';
        }
      }
    }

    _deliveryText(meters) {
      // Regras vindas de custom.delivery_rules (JSON) via data-delivery-rules; senão texto genérico.
      try {
        var rules = this.dataset.deliveryRules ? JSON.parse(this.dataset.deliveryRules) : null;
        if (rules && rules.length) {
          for (var i = 0; i < rules.length; i++) {
            if (meters >= rules[i].min && meters <= rules[i].max) return rules[i].text;
          }
        }
      } catch (e) { /* ignora */ }
      return this.dataset.deliveryFallback || 'Prazo de despacho calculado conforme a potência, a metragem e a disponibilidade de produção.';
    }

    _setText(sel, val) { var el = this.querySelector(sel); if (el) el.textContent = val; }
    _setProp(name, val) {
      var el = this.querySelector('[data-prop="' + name + '"]');
      if (el) el.value = val;
    }

    // ---- add to cart ----
    async _onAdd(e) {
      e.preventDefault();
      var v = this.currentVariant;
      if (!v || !v.available || this.meters > this.max) return;
      if (this._busy) return; this._busy = true;

      var original = this.addBtn.textContent;
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'ADICIONANDO...';
      this._say('Adicionando ' + this.meters + ' metros ao carrinho.');

      var properties = {};
      this.querySelectorAll('[data-prop]').forEach((el) => { properties[el.dataset.prop] = el.value; });

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: this._quantity(), properties: properties }] })
        });
        if (!res.ok) { var err = await res.json().catch(() => ({})); throw new Error(err.description || 'Erro ao adicionar'); }

        this.addBtn.textContent = 'ADICIONADO AO CARRINHO';
        this._say(this.meters + ' metros adicionados ao carrinho.');
        await this._refreshCart();
        this._openDrawer();
        setTimeout(() => { this.addBtn.disabled = false; this.render(); this._busy = false; }, 1800);
      } catch (err) {
        this.addBtn.textContent = original;
        this.addBtn.disabled = false;
        this._busy = false;
        this._say('Não foi possível adicionar. ' + (err.message || '') );
        console.warn('[aisen] add to cart', err);
      }
    }

    async _refreshCart() {
      try {
        var cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
        // atualiza contador do header AISEN
        var count = document.querySelector('.aisen-hdr__count');
        if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
        else {
          var cartLink = document.querySelector('.aisen-hdr__cart');
          if (cartLink && cart.item_count > 0) {
            var b = document.createElement('span'); b.className = 'aisen-hdr__count'; b.textContent = cart.item_count; cartLink.appendChild(b);
          }
        }
        // notifica o tema (Horizon cart-icon/drawer escutam eventos próprios; disparo genérico + o nativo se existir)
        document.dispatchEvent(new CustomEvent('aisen:cart-updated', { detail: cart, bubbles: true }));
      } catch (e) { /* ignora */ }
    }

    _openDrawer() {
      // Best-effort: abre o cart-drawer nativo do Horizon se estiver presente; senão, deixa o usuário ir ao /cart.
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        var dialog = drawer.querySelector('dialog');
        try {
          if (typeof drawer.showDialog === 'function') drawer.showDialog();
          else if (typeof drawer.open === 'function') drawer.open();
          else if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        } catch (e) { /* fallback: nada */ }
      }
    }

    _devWarnMetafields() {
      if (!DEV) return;
      var required = ['sales_increment_m', 'minimum_order_m', 'maximum_online_order_m', 'maximum_circuit_m'];
      var missing = (this.dataset.missingMetafields || '').split(',').filter(Boolean);
      if (missing.length) console.warn('[aisen] metafields ausentes (usando defaults):', missing.join(', '));
    }
  }

  customElements.define('aisen-meter-selector', AisenMeterSelector);
})();
